import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ErrorPage, ErrorIcon, Title, Description, Button } from "./ErrorPage.wrapper";
import useOnlineStatus from "../../../hooks/useOnlineStatus";


const ErrorNoNetworkPage = () => {
  const [t] = useTranslation("translations");
  const { onlineStatus } = useOnlineStatus();
  const lastPage = sessionStorage.getItem("lastPageBeforeError");

  useEffect(() => {
    handleRefresh();
  }, [onlineStatus]);

  const handleRefresh = () => {
    if (onlineStatus === "online") {
      if (lastPage) {
        window.location.href = lastPage;
      } else {
        window.history.back(); 
      }
    }
  };

  return (
    <ErrorPage>
      <ErrorIcon icon_type="network" />
      <Title>{t("ErrorPage.error_no_network_page__title")}</Title>
      <Description>{t("ErrorPage.error_no_network_page__description")}</Description>
      <Button onClick={() => handleRefresh()}>{t("Retry")}</Button>
    </ErrorPage>
  );
};

export default ErrorNoNetworkPage;
